import { render, staticRenderFns } from "./BootstrapDatetimepicker.vue?vue&type=template&id=270ea213"
import script from "./BootstrapDatetimepicker.vue?vue&type=script&lang=js"
export * from "./BootstrapDatetimepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports